import profile from './profile';
import settings from './settings';

export default {
  chats: {
    title: 'Чати',
    search: {
      placeholder: 'Пошук повідомлень або користувачів',
    },
  },
  profile,
  settings,
}
